import { useEffect } from 'react'

import { logAndCaptureLeftResult } from '../utils/errorTools'

interface ConditionCallback<L> {
  (left: L): boolean
}

export const useLogAndCaptureLeftResult = <L>(
  result: ({ _tag: 'Left' } & L) | { _tag: 'Right' },
  condition?: ConditionCallback<L>,
): void => {
  useEffect(() => {
    if (result._tag === 'Right' || (condition && !condition(result))) {
      return
    }
    logAndCaptureLeftResult(result)
  }, [condition, result])
}
